import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CalendarViewWeekIcon(props: IconProps) {
    return <Icon {...props} iconKey={"calendar_view_week"}/>
}
